import React, { useEffect, useState } from "react";
import { adminGetAllBanners, adminDeleteBanner } from "../api/admin";
import BannerTable from "../components/BannerTable";
import BannerForm from "../components/BannerForm";
import "./BannersPage.css";
import { toast } from "react-toastify";

const BannersPage = () => {
  const [banners, setBanners] = useState([]);
  const [editingBanner, setEditingBanner] = useState(null);
  const [showForm, setShowForm] = useState(false);
  
  // RBAC check
  const hasWritePermission = () => {
    const role = localStorage.getItem("adminRole");
    if (role === "admin") return true;
    const permissions = JSON.parse(localStorage.getItem("adminPermissions") || "[]");
    return permissions.includes("Banners:write");
  };
  const canWrite = hasWritePermission();

  const fetchBanners = async () => {
    const res = await adminGetAllBanners();
    setBanners(res.data || []);
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;
    try {
      await adminDeleteBanner(id);
      fetchBanners();
      toast.success("Banner deleted successfully! 🗑️");
    } catch (error) {
      console.error("Error deleting banner:", error);
      toast.error(error.response?.data?.message || "Failed to delete banner. ❌");
    }
  };

  const handleEdit = (banner) => {
    setEditingBanner(banner);
    setShowForm(true);
  };

  const clearEdit = () => {
    setEditingBanner(null);
    setShowForm(false);
  };

  return (
    <div className="admin-page">
      {!showForm ? (
        <>
          <div className="page-header">
            <h2 className="adminproducts">Banners</h2>
            <div className="header-actions">
              {canWrite && (
                <button className="btn-add-product" onClick={() => { setEditingBanner(null); setShowForm(true); }}>
                  + Add Banner
                </button>
              )}
            </div>
          </div>

          <BannerTable banners={banners} onDelete={handleDelete} onEdit={handleEdit} canWrite={canWrite} />
        </>
      ) : (
        <>
          <div className="page-header">
            <div className="header-with-back">
              <button className="back-btn" onClick={clearEdit}>← Back</button>
              <h2 className="adminproducts">
                {editingBanner ? "Update Banner" : "Create New Banner"}
              </h2>
            </div>
          </div>
          <div className="form-inline-container">
            <BannerForm
              banner={editingBanner}
              onSuccess={() => {
                fetchBanners();
                clearEdit();
              }}
              onCancel={clearEdit}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default BannersPage;

